// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import updateSearchFields from "@store/Framework/Store/Store/Components/FastenersTable/Handlers/UpdateSearchFields";
import React from "react";

interface ProductFastenersPaginationProps {
    pagination: PaginationModel;
    productId: string;
}

export interface ProductFastenersPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const productFastenersPaginationStyles: ProductFastenersPaginationStyles = {};

const styles = productFastenersPaginationStyles;

const ProductFastenersPagination = ({ pagination, productId }: ProductFastenersPaginationProps) => {
    const dispatch = useAppDispatch();

    const changePage = (newPageIndex: number) => {
        if (!productId) {
            return;
        }

        dispatch(
            updateSearchFields({
                productId,
                page: newPageIndex,
            }),
        );
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (!productId) {
            return;
        }

        const newPageSize = parseInt(event.currentTarget.value, 10);

        dispatch(
            updateSearchFields({
                productId,
                page: 1,
                pageSize: newPageSize,
            }),
        );
    };

    if (pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

export default ProductFastenersPagination;
